import { ToolbarMenu as NdsToolbarMenu } from 'neon-design-system';

interface Props {
  selectedOption: string;
  options: {
    title: string;
    value: string;
  }[];
  onChange: (value: string | number) => void;
}

export const ToolbarMenu = ({ onChange, options, selectedOption }: Props) => {
  return <NdsToolbarMenu items={options} value={selectedOption} onChange={onChange} />;
};
